import {YesNoToBool} from './YesNoToBool';

enum Entries {
  one,
  two,
  multi
}


const strToPrice: {
  [key: string]: number
} = {
  'Виза без отеля 3-4 дня однократный въезд': 85,
  'Виза без отеля 3-4 дня двойной въезд': 95,
  'Виза без отеля 3-4 дня многократный въезд': 105,

  'Виза с отелем 3-4 дня однократный въезд': 60,
  'Виза с отелем 3-4 дня двойной въезд': 80,
  'Виза с отелем 3-4 дня многократный въезд': 100,
  'Виза с отелем 3-4 дня однократный въезд с гарантией': 95,
  'Виза с отелем 3-4 дня двойной въезд с гарантией': 115,
  'Виза с отелем 3-4 дня многократный въезд с гарантией': 135,

  'Виза с отелем 48 часов однократный въезд': 85,
  'Виза с отелем 48 часов двойной въезд': 100,
  'Виза с отелем 48 часов многократный въезд': 120,
  'Виза с отелем 48 часов однократный въезд с гарантией': 120,
  'Виза с отелем 48 часов двойной въезд с гарантией': 135,
  'Виза с отелем 48 часов многократный въезд с гарантией': 140,

  'Виза с отелем 24 часа однократный въезд': 105,
  'Виза с отелем 24 часа двойной въезд': 125,
  'Виза с отелем 24 часа многократный въезд': 145,
  'Виза с отелем 24 часа однократный въезд с гарантией': 150,
  'Виза с отелем 24 часа двойной въезд с гарантией': 170,
  'Виза с отелем 24 часа многократный въезд с гарантией': 190,

  'Виза с отелем 6 часов однократный въезд': 200,
  'Виза с отелем 6 часов двойной въезд': 220,
  'Виза с отелем 6 часов многократный въезд': 240,
  'Виза с отелем 6 часов однократный въезд с гарантией': 240,
  'Виза с отелем 6 часов двойной въезд с гарантией': 260,
  'Виза с отелем 6 часов многократный въезд с гарантией': 280,
}

export const serviceStringCreator = (receiving_term: string, withHotel: string, entries: Entries, isGuaranteed: string) => {
  const entriesStr = () => {
    switch (entries) {
      case Entries.one:
        return ' однократный въезд'
      case Entries.two:
        return ' двойной въезд'
      case Entries.multi:
        return ' многократный въезд'
      default:
        return ''
    }
  }

  const name = 'Виза ' + (YesNoToBool(withHotel) ? 'с отелем ' : 'без отеля ') + receiving_term + entriesStr() + (YesNoToBool(isGuaranteed)
    ? ' с гарантией' : '')
  const price = strToPrice[name] || 0
  return {
    name: (name + '-' + price), price
  }
}